import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n\n  &:last-child {\n    margin-bottom: ", "px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { GridColumn } from '@scp/ui-shared/components/grid';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { ChildGroupWrapper } from './baseComponents';
import { isOptionChecked } from './utils';
var GroupItemWrapper = styled(withoutProps(GridColumn, ['bottomSpacing']))(_templateObject(), function (_ref) {
  var bottomSpacing = _ref.bottomSpacing;
  return bottomSpacing ? 8 : 0;
});
export var SwitchGroupBaseOption = function SwitchGroupBaseOption(_ref2) {
  var size = _ref2.size,
      bottomSpacing = _ref2.bottomSpacing,
      disabled = _ref2.disabled,
      onChange = _ref2.onChange,
      invalid = _ref2.invalid,
      itemComponent = _ref2.itemComponent,
      _ref2$parentComponent = _ref2.parentComponent,
      parentComponent = _ref2$parentComponent === void 0 ? itemComponent : _ref2$parentComponent,
      name = _ref2.name,
      item = _ref2.item,
      selectedValue = _ref2.selectedValue,
      _ref2$defaultExpanded = _ref2.defaultExpanded,
      defaultExpanded = _ref2$defaultExpanded === void 0 ? false : _ref2$defaultExpanded,
      _ref2$scrollToSelecte = _ref2.scrollToSelected,
      scrollToSelected = _ref2$scrollToSelecte === void 0 ? false : _ref2$scrollToSelecte,
      _ref2$itemLabelRender = _ref2.itemLabelRenderer,
      itemLabelRenderer = _ref2$itemLabelRender === void 0 ? function (item) {
    return item.label || item.value.toString();
  } : _ref2$itemLabelRender;
  var isChecked = isOptionChecked(item, selectedValue);
  var groupName = "".concat(name, "-").concat(item.value);
  var optionRef = useRef(null);
  useEffect(function () {
    if (scrollToSelected && isChecked && optionRef.current) {
      optionRef.current.scrollIntoView({
        block: 'center'
      });
    }
  }, [scrollToSelected, isChecked]);
  return React.createElement(React.Fragment, null, React.createElement(GroupItemWrapper, {
    size: item.size || size,
    bottomSpacing: bottomSpacing,
    ref: optionRef
  }, parentComponent({
    onChange: onChange,
    invalid: invalid,
    name: name,
    disabled: disabled || item.disabled,
    checked: isChecked,
    label: itemLabelRenderer(item),
    id: groupName,
    value: item.value.toString()
  })), (isChecked || defaultExpanded) && item.children && item.children.length > 0 && React.createElement(ChildGroupWrapper, null, item.children.map(function (childItem) {
    return React.createElement(SwitchGroupBaseOption, {
      key: childItem.value,
      size: size,
      bottomSpacing: bottomSpacing,
      disabled: disabled,
      onChange: onChange,
      name: groupName,
      invalid: invalid,
      itemComponent: itemComponent,
      item: childItem,
      selectedValue: selectedValue,
      itemLabelRenderer: itemLabelRenderer
    });
  })));
};